import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    private readonly PROD_GA_ID = 'UA-142677270-2';
    private readonly NON_PROD_GA_ID = 'UA-142677270-2';
    private GA_ID = '';

    calculateGAID(appEnv: string) {
        return appEnv === 'prod' ? this.PROD_GA_ID : this.NON_PROD_GA_ID;
    }

    /* eslint-disable @typescript-eslint/no-explicit-any */
    setupGoogleAnalytics(appEnv: string) {
        this.GA_ID = this.calculateGAID(appEnv);

        const gaScript = document.createElement('script');
        gaScript.type = 'text/javascript';
        gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.GA_ID}`;

        const scriptElement = document.getElementsByTagName('script')[0];
        scriptElement.parentNode.insertBefore(gaScript, scriptElement);

        (window as any).dataLayer = (window as any).dataLayer || [];
        this.gtag('js', new Date());
    }

    gtag(event: string, data: any) {
        (window as any).dataLayer.push(event);
        (window as any).dataLayer.push(data);
    }

    pageNavigation(event: string, data: any) {
        (window as any).dataLayer.push(event);
        (window as any).dataLayer.push(this.GA_ID);
        (window as any).dataLayer.push(data);
    }

    event(eventName: string, data: any) {
        (window as any).dataLayer.push('event');
        (window as any).dataLayer.push(eventName);
        (window as any).dataLayer.push(data);
    }
}
